module.exports = __webpack_public_path__ + "static/media/HelpImage.eb1c69e7.jpg";